<app-common-offcanvas
  width="696px"
  [opened]="opened()"
  (close)="closeContacts()"
>
  <div class="header">
    <div class="w-100 d-flex align-items-center justify-content-between gap-12 px-4">
      <h2 class="h2-heading m-0 p-0 d-flex align-items-center gap-12">
        <i class="icon ic-mail-20"></i>
        <span>Contacts</span>
      </h2>

      <button
        type="button"
        class="btn btn-primary d-flex align-items-center gap-8"
        [disabled]="isLoading()"
        (click)="onAddContact()"
      >
        <i class="icon ic-add-20"></i>
        <span>Add Contact</span>
      </button>
    </div>
  </div>

  <div class="contacts-content mw-100 w-100 h-100 overflow-auto d-flex flex-column p-4">
    @if (isLoading()) {
      <app-loader class="m-auto"/>
    } @else {
      <app-list-grid-client-side
        [colDefs]="colDefs"
        [rowData]="viewContacts()"
        [rowSelection]="contactsRowSelection"
        [isFullWidthRow]="isFullWidthRow"
        [fullWidthCellRenderer]="fullWidthCellRenderer"
        [getRowHeight]="getRowHeight"
        [pagination]="false"
        [gridOptions]="gridOptions"
      />
    }
  </div>
</app-common-offcanvas>
